import $ from 'jquery';
import flatpickr from 'flatpickr';

function setDaysKeyboardsAvailable(availableDays) {
  if (availableDays) {
    availableDays.forEach((day) => {
      if (day.hasAttribute('tabindex') && day.getAttribute('tabindex') === '-1') {
        day.setAttribute('tabindex', '0');
      }
    });
  }
}

// Hotel-specific closures map. Add more hotel codes/dates here as needed.
const HOTEL_CLOSURES = {
  '0180': ['2026-01-04', '2026-01-05', '2026-01-06', '2026-01-07', '2026-01-08'],
};

function isHotelClosedOn(hotelCode, dateStr) {
  const dates = HOTEL_CLOSURES[hotelCode];
  return Array.isArray(dates) && dates.indexOf(dateStr) !== -1;
}

class Calendar {
  options = {
    classes: {
      container: '.booking-widget__calendar',
      close: '.booking-calendar-widget__close',
      open: '.booking-calendar__open',
      clear: '.booking-calendar-widget__clear',
      legend: '.js-calendar-legend',
    },
    duration: 200,
  };

  constructor() {
    this.calendar = $(this.options.classes.container);
    this.openClass = 'open';
    this.closeButton = this.calendar.find(this.options.classes.close);
    this.openButton = $(this.options.classes.open);
    this.clearButton = $(this.options.classes.clear);
    this.legend = $(this.options.classes.legend);
    this.onClick();
    this.onClear();
    this.scopeHotel = [];

    this.fp_OpenTable = flatpickr('.js-calendar-fp__dateOpenTable', {
      dateFormat: 'F d, Y',
      appendTo: document.querySelector('.js-calendar-fp-container__dateOpenTable'),
      showMonths: 12,
      disableMobile: true,
      inline: true,
      minDate: new Date(),
      onChange(selectedDates) {
        // eslint-disable-next-line no-underscore-dangle
        const _this = this; const
          dateArr = selectedDates.map((date) => _this.formatDate(date, 'Y-m-d'));
        // eslint-disable-next-line no-use-before-define
        onApplySingle(dateArr, this);
        // eslint-disable-next-line no-use-before-define
        verticalView(this);
      },
      // eslint-disable-next-line no-use-before-define
      onValueUpdate() { verticalView(this); },
      onReady() {
        const idFpCalendar = Math.floor(Math.random() * 1000) + 1;
        this.calendarContainer.setAttribute('id', `booking-fp-container_${idFpCalendar}`);
        this.input.setAttribute('data-id-fp', `booking-fp-container_${idFpCalendar}`);
        // eslint-disable-next-line no-use-before-define
        verticalView(this);
      },
      onDayCreate(dObj, dStr, fp, dayElem) {
        // Try to get the current hotel's code from the stay hidden input (present in the widget)
        const hotelCodeInput = document.querySelector('.js-booking-stay-code-hotel');
        const code = hotelCodeInput ? hotelCodeInput.value : null;

        if (!code) return;

        // eslint-disable-next-line no-underscore-dangle
        const _this = fp;
        const dateDay = _this.formatDate(dayElem.dateObj, 'Y-m-d');
        const previous = new Date(dayElem.dateObj.getTime());
        previous.setDate(dayElem.dateObj.getDate() - 1);
        const previousDay = _this.formatDate(previous, 'Y-m-d');

        // Hotel-specific closure applies even if availability data isn't loaded
        if (isHotelClosedOn(code, dateDay)) {
          console.debug('Booking calendar: applying hotel-specific closure for', code, dateDay);
          dayElem.classList.add('flatpickr-disabled', 'flatpickr-closed');
          return;
        }

        // eslint-disable-next-line no-use-before-define
        const dateArray = getDateFn(code);

        if (!dateArray
          || ((dateArray.data === null || dateArray.data === undefined))
          || (Array.isArray(dateArray.data) && dateArray.data.length <= 0)) {
          return;
        }

        dayElem.classList.add('flatpickr-disabled');

        $.each(dateArray.data, (i, v) => {
          if (v.date === dateDay) {
            // enable this day
            dayElem.classList.remove('flatpickr-disabled');
          }

          const previousEl = dateArray.data[i - 1];

          if (dayElem.classList.contains('flatpickr-disabled') && previousEl && previousEl.date === previousDay) {
            dayElem.classList.remove('flatpickr-disabled');
            dayElem.classList.add('allow-departure');
          }
        });
      },
    });
  }

  CheckinCheckOut(codeHotel) {
    // eslint-disable-next-line no-use-before-define
    const dateArray = getDateFn(codeHotel);
    const minDate = document.querySelector(`[data-value="${codeHotel}"]`)?.dataset.calendarStartDate || new Date();

    const calendarContainer = document.querySelector('.js-calendar-fp-container__dateCheckinCheckOut');
    const hasPrices = Array.isArray(dateArray?.data) && dateArray.data.some((d) => !!d.minPrice);

    if (calendarContainer) {
      calendarContainer.classList.toggle('calendar-no-prices', !hasPrices);
    }

    this.fp_CheckinCheckOut = flatpickr('.js-calendar-fp__dateCheckinCheckOut', {
      dateFormat: 'F d, Y',
      appendTo: document.querySelector('.js-calendar-fp-container__dateCheckinCheckOut'),
      showMonths: 12,
      disableMobile: true,
      mode: 'range',
      inline: true,
      minDate,
      onChange(selectedDates) {
        // eslint-disable-next-line no-use-before-define
        onApply(selectedDates, this);
        // eslint-disable-next-line no-use-before-define
        verticalView(this);
        setDaysKeyboardsAvailable(document.querySelectorAll('.flatpickr-day:not(.flatpickr-disabled)'));
      },
      // eslint-disable-next-line no-use-before-define
      onValueUpdate() { verticalView(this); },
      onReady() {
        const idFpCalendar = Math.floor(Math.random() * 1000) + 1;
        this.calendarContainer.setAttribute('id', `booking-fp-container_${idFpCalendar}`);
        this.input.setAttribute('data-id-fp', `booking-fp-container_${idFpCalendar}`);
        // eslint-disable-next-line no-use-before-define
        verticalView(this);
      },
      onDayCreate(dObj, dStr, fp, dayElem) {
        if (!dateArray
          || ((dateArray.data === null || dateArray.data === undefined))
          || (Array.isArray(dateArray.data) && dateArray.data.length <= 0)) {
          // eslint-disable-next-line no-use-before-define
          calendar.legend.hide();
          return;
        }

        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        const dateDay = _this.formatDate(dayElem.dateObj, 'Y-m-d');
        const previous = new Date(dayElem.dateObj.getTime());
        previous.setDate(dayElem.dateObj.getDate() - 1);
        const previousDay = _this.formatDate(previous, 'Y-m-d');

        if (isHotelClosedOn(codeHotel, dateDay)) {
          console.debug('Booking calendar: applying hotel-specific closure for', codeHotel, dateDay);
          dayElem.classList.add('flatpickr-disabled', 'flatpickr-closed');
          // Ensure the day label is displayed but remove price/extra elements
          while (dayElem.firstChild) {
            dayElem.removeChild(dayElem.firstChild);
          }
          const dateNumber = document.createElement('span');
          dateNumber.classList.add('flatpickr-date-number');
          dateNumber.textContent = dayElem.textContent;
          dayElem.appendChild(dateNumber);
          return;
        }

        // eslint-disable-next-line no-use-before-define
        calendar.legend.show();
        dayElem.classList.add('flatpickr-disabled');

        $.each(dateArray.data, (i, v) => {
          const dayWrapper = document.createElement('span');
          dayWrapper.classList.add('flatpickr-day-wrapper');
          if (v.date === dateDay) {
            const dateNumber = document.createElement('span');
            dateNumber.classList.add('flatpickr-date-number');
            dateNumber.textContent = dayElem.textContent;
            dayWrapper.appendChild(dateNumber);

            if (v.minPrice) {
              const priceElem = document.createElement('span');
              priceElem.classList.add('flatpickr-price');
              const price = new Intl.NumberFormat('en-US').format(Math.round(v.minPrice));
              priceElem.textContent = `$${price}`;
              dayWrapper.appendChild(priceElem);
            }

            while (dayElem.firstChild) {
              dayElem.removeChild(dayElem.firstChild);
            }
            dayElem.appendChild(dayWrapper);
          }
          if (v.date.indexOf(dateDay) !== -1) {
            dayElem.classList.remove('flatpickr-disabled');
          }
          if (dateDay === v.date && v.dealday === true) {
            dayWrapper.classList.add('flatpickr-savings');
          }
          if (dateDay === v.date && v.minMinLOS > 1) {
            dayElem.classList.add('flatpickr-min');
          }

          const previousEl = dateArray.data[i - 1];

          if (dayElem.classList.contains('flatpickr-disabled') && previousEl && previousEl.date === previousDay) {
            dayElem.classList.remove('flatpickr-disabled');
            dayElem.classList.add('allow-departure');
          }
        });
      },
    });
    this.fp_CheckinCheckOut.clear();
    this.fp_CheckinCheckOut.set('inline', true);
  }

  open() {
    if (this.calendar.hasClass(this.openClass)) {
      return false;
    }

    this.calendar.stop().show().animate({ right: 0 }, this.options.duration, 'linear', this.#afterOpen.bind(this));
    return true;
  }

  #afterOpen() {
    this.calendar.addClass(this.openClass).attr('aria-hidden', 'false');
    $('body > :visible:not(.booking-widget__calendar)').attr('aria-hidden', 'true');
    this.closeButton[0].focus();

    setDaysKeyboardsAvailable(this.calendar[0].querySelectorAll('.flatpickr-day:not(.flatpickr-disabled):not(.hidden)'));

    this.calendar[0].addEventListener('keydown', (e) => {
      const day = e.target;
      if (!day.classList.contains('flatpickr-day') || day.classList.contains('flatpickr-disabled') || day.classList.contains('hidden')) return;

      const daysArr = Array.from(this.calendar[0].querySelectorAll('.flatpickr-day:not(.flatpickr-disabled):not(.hidden)'));
      const idx = daysArr.indexOf(day);
      const daysInRow = 7;

      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          if (idx > 0) daysArr[idx - 1].focus();
          break;
        case 'ArrowRight':
          e.preventDefault();
          if (idx < daysArr.length - 1) daysArr[idx + 1].focus();
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (idx - daysInRow >= 0) daysArr[idx - daysInRow].focus();
          break;
        case 'ArrowDown':
          e.preventDefault();
          if (idx + daysInRow < daysArr.length) daysArr[idx + daysInRow].focus();
          break;
        case 'Tab':
          e.preventDefault();
          if (!e.shiftKey) {
            setTimeout(() => {
              this.closeButton[0].focus();
            }, 0);
          } else {
            setTimeout(() => {
              this.clearButton[0].focus();
            }, 0);
          }
          break;
        case 'Space':
        case ' ':
        case 'Enter':
          e.preventDefault();
          day.click();
          setTimeout(() => {
            const focusDay = this.calendar[0].querySelector('.flatpickr-day.startRange:not(.flatpickr-disabled):not(.hidden)');
            if (focusDay) focusDay.focus();
          }, 0);
          break;
        default:
          break;
      }
    });

    this.closeButton[0].addEventListener('keydown', (e) => {
      // Shift+Tab from close button focuses first available day
      if (e.key === 'Tab' && e.shiftKey) {
        const daysArr = Array.from(this.calendar[0].querySelectorAll('.flatpickr-day:not(.flatpickr-disabled):not(.hidden)'));
        if (daysArr.length > 0) daysArr[0].focus();
      }
    });
  }

  close() {
    this.calendar.stop().animate({ right: -1 * this.calendar.width() }, this.options.duration, 'linear', this.#afterClose.bind(this));
    return true;
  }

  #afterClose() {
    this.calendar.hide().removeClass(this.openClass).attr('aria-hidden', 'true').removeAttr('style');
    $('body > :visible:not(.booking-widget__calendar)').removeAttr('aria-hidden');
    $('.calendar-fp-vertical .flatpickr-calendar').removeClass(this.openClass).removeAttr('style').parent()
      .removeAttr('style');
  }

  onClick() {
    this.openButton.on('click', (eo) => {
      eo.preventDefault();
      const idFpCalendar = eo.target.dataset.idFp;
      const calendarContainer = $(`#${idFpCalendar}`);
      if (calendarContainer.length > 0) {
        calendarContainer.addClass('open').parent().show();
      }
    });
  }

  onClear() {
    this.clearButton.on('click', (e) => {
      e.preventDefault();

      if ($(this.fp_OpenTable.calendarContainer).is(':visible')) {
        this.fp_OpenTable.clear();
      }

      if ($(this.fp_CheckinCheckOut.calendarContainer).is(':visible')) {
        this.fp_CheckinCheckOut.clear();
      }
    });

    setDaysKeyboardsAvailable(this.availableDays);
  }
}

// eslint-disable-next-line consistent-return
function getDateFn(code) {
  let result = {};
  let notCode = true;

  // eslint-disable-next-line no-use-before-define
  for (let i = 0; i < calendar.scopeHotel.length; i += 1) {
    // eslint-disable-next-line no-use-before-define
    if (calendar.scopeHotel[i].hotelCode === code) {
      notCode = false;

      // eslint-disable-next-line no-use-before-define
      return calendar.scopeHotel[i];
    }
  }

  if (notCode) {
    $.ajax({
      // eslint-disable-next-line camelcase,no-undef
      url: ajax_urls.url, // insert api
      global: false,
      dataType: 'json',
      async: false,
      data: {
        action: 'booking-availability-calendar',
        hotelCode: code,
        csd: '',
        months2show: '12',
      },
      beforeSend() {
        $('#stay-content form').addClass('field-form--disabled');
      },
      complete() {
        $('#stay-content form').removeClass('field-form--disabled');
      },
    }).done((response) => {
      // eslint-disable-next-line no-use-before-define
      calendar.scopeHotel.push({ hotelCode: code, data: response.data });
      result = response;
    }).fail(() => {
      result = false;
    });
    return result;
  }
}

function onApply(dateArr, fpInstance) {
  const form = $('#stay-content form');
  const action = form.attr('action') || '';
  let format = 'M j, Y';

  if (action.includes('be.synxis.com')) {
    format = 'm/d/y';
  }

  const startDate = dateArr[0] ? fpInstance.formatDate(dateArr[0], format) : '';
  const endDate = dateArr[1] ? fpInstance.formatDate(dateArr[1], format) : '';

  $('#bookingStartDate').val(startDate);
  $('#bookingEndDate').val(endDate);
  // eslint-disable-next-line no-unused-expressions,no-use-before-define
  endDate ? calendar.close() : '';
}
function onApplySingle(date, fpCalendar) {
  // eslint-disable-next-line no-param-reassign
  fpCalendar.input.previousElementSibling.value = date;
  // eslint-disable-next-line no-unused-expressions,no-use-before-define
  date.length ? calendar.close() : '';
}
function verticalView(fpCalendar) {
  const fp = fpCalendar;
  const dayContainer = fp.days.className;
  const idFpCalendar = fp.calendarContainer.id;

  // eslint-disable-next-line no-use-before-define
  hideHorizontalViewElement(idFpCalendar);

  $(`#${idFpCalendar} .${dayContainer}`).each(function (i) {
    // eslint-disable-next-line no-use-before-define
    const month = getCurrentMonth(fp, i);
    // eslint-disable-next-line no-use-before-define
    const year = getCurrentYear(fp, i);

    if ($(this).find('div').length === 0) {
      $(this).prepend(`
        <div class="verticalView-container">
          <div class="flatpickr-current-MonthYear">
             ${month} ${year}
          </div>
          <div class="flatpickr-weekdays">
            <div class='flatpickr-weekdaycontainer'>
              <span class="flatpickr-weekday">S</span>
              <span class="flatpickr-weekday">M</span>
              <span class="flatpickr-weekday">T</span>
              <span class="flatpickr-weekday">W</span>
              <span class="flatpickr-weekday">T</span>
              <span class="flatpickr-weekday">F</span>
              <span class="flatpickr-weekday">S</span>
            </div>
          </div>
        <div>`);
    }
  });
}
function hideHorizontalViewElement(idFpCalendar) {
  $(`#${idFpCalendar} .flatpickr-days`).css('flex-direction', 'column');
  $(`#${idFpCalendar} .flatpickr-rContainer > .flatpickr-weekdays`).hide();
}
function getCurrentMonth(fpCalendar, item) {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const distance = (item % 12) + fpCalendar.currentMonth;
  let month = 0;
  month = months[distance];

  if (distance > months.length - 1) {
    month = months[(item - (months.length - fpCalendar.currentMonth)) % 12];
  }
  return month;
}
function getCurrentYear(fpCalendar, item) {
  let { currentYear } = fpCalendar;
  const months = 12;
  const distance = item + fpCalendar.currentMonth;
  const newYear = currentYear + Math.floor((item + fpCalendar.currentMonth) / months);

  if (distance >= months) {
    currentYear = newYear;
  }
  return currentYear;
}
const calendar = new Calendar();

export default calendar;
